// fetchCountries.js
import { message } from "antd";
import { selectBaseUrl, selectProdTestUrl } from "../../redux/slices/envSlice";
import { token } from "../../constants/Constants";
import { logout } from "../../redux/slices/userSlice";
import { fetch_coustomers } from "../../endpoints/API";

export const fetchCustomers = async (setCustomers, baseUrl, prodTestUrl) => {
  try {
    const response = await fetch_coustomers();
    if (response.statusText=="OK") {
      const data =  response?.data;
      setCustomers(data);
    } else {
      message.error("Failed to fetch customers.");
    }
  } catch (error) {
    message.error(error?.response?.data?.error||"An error occurred while fetching customers.");
  }
};
